import type { RootState } from '~/store';

export const isClanHubEnabledSelector = (state: RootState) => state.settings.clanhub.isEnabled;

export const treasuryMinDaysInClanSelector = (state: RootState) => state.settings.treasuryMinDaysInClan;

export const settingsFormatsSelector = (state: RootState) => state.settings.formats;
